import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../utilities/common/data';
import dashboardRepository from '../repositories/general/dashboardRepository';

export const useDashboardStore = defineStore('dashboardStore', {
  state: () => ({
    mainCard: {
      destination: null,
      typeDestination: null,
      event: null,
      blog: null,
    },
    listBlog: [],
    listEvent: [],
    listAnnouncement: [],
  }),
  actions: {
    async getData() {
      try {
        const dataDashboard = await dashboardRepository.getData();
        console.log(dataDashboard);
        if (dataDashboard.data.status === 200) {
          this.mainCard.destination = dataDashboard.data.data.main_card.destination;
          this.mainCard.typeDestination = dataDashboard.data.data.main_card.type_destination;
          this.mainCard.event = dataDashboard.data.data.main_card.event;
          this.mainCard.blog = dataDashboard.data.data.main_card.blog;
          this.listBlog = dataDashboard.data.data.list_blog;
          this.listEvent = dataDashboard.data.data.list_event;
          this.listAnnouncement = dataDashboard.data.data.list_announcement;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useDashboardStore, import.meta.webpackHot));
}
